import React from 'react'
import './NetworkLoader.css'

export default function NetworkLoader({ compact = false, label = 'Loading network data…' }) {
  return (
    <div className={`network-loader${compact ? ' network-loader--compact' : ''}`} role="status" aria-live="polite">
      <svg className="network-loader__globe" viewBox="0 0 64 64" aria-hidden="true" focusable="false">
        <g className="network-loader__grid">
          <circle cx="32" cy="32" r="20" />
          <ellipse cx="32" cy="32" rx="9" ry="20" />
          <path d="M12 32h40M15 22h34M15 42h34" />
        </g>
        <circle className="network-loader__orbit" cx="32" cy="32" r="28" pathLength="100" />
      </svg>
      <span className="network-loader__label">{label}</span>
    </div>
  )
}
